export const COLOR = {
  PRIMARY: {
    MAIN: '#266950',
    100: '#00BC76',
    200: '#47BA8F',
    500: '#266950',
  },
  GENERIC: {
    0: '#FFFFFF',
    200: '#CFCFCF',
    900: '#262626',
    100: '#000000',
  },
  NEUTRAL: {
    100: '#F5F7FB',
    200: '#CAD4E0',
    300: '#CBCBCB',
    400: '#8A8A8A',
    500: '#525252',
  },
};
